var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mylevel-root", style: _vm.cssVars() }, [
    _c(
      "div",
      {
        staticClass: "mylevel-main",
        class: [
          _vm.baseInfo && _vm.baseInfo.currGrade ? "level-on" : "level-off",
        ],
      },
      [
        _c(
          "div",
          {
            staticClass: "custom-nav-block",
            style: `paddingTop:${_vm.barHeight}px`,
          },
          [
            _c("van-nav-bar", {
              staticClass: "van-bar",
              attrs: { title: "", "left-arrow": "" },
              on: { "click-left": _vm.closeWeb },
              scopedSlots: _vm._u([
                {
                  key: "left",
                  fn: function () {
                    return [
                      _c("img", {
                        staticClass: "left-nav",
                        attrs: {
                          src: require("@/assets/packageAssets/common/arrow09.png"),
                          alt: "",
                        },
                      }),
                      _c("span", { staticClass: "tit-left" }, [
                        _vm._v(_vm._s(_vm.$t("lang.host.myLevel"))),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
        _c("div", { staticClass: "level-block" }, [
          _vm.baseInfo
            ? _c("div", {
                class: [
                  "level-img",
                  _vm.baseInfo.currGrade > 0 ? "top-level-on" : "top-level-off",
                ],
              })
            : _vm._e(),
          _c("div", { staticClass: "level-con" }, [
            _c(
              "div",
              { staticClass: "level-text" },
              [
                _vm._v(" Lv."),
                _vm.baseInfo
                  ? [_vm._v(_vm._s(_vm.baseInfo.currGrade || 0))]
                  : _vm._e(),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "progress-box" },
              [
                _vm.baseInfo
                  ? _c("div", { staticClass: "progress-level" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("lang.LV")) +
                            "." +
                            _vm._s(_vm.baseInfo.currGrade)
                        ),
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("lang.LV")) +
                            "." +
                            _vm._s(_vm.baseInfo.nextGrade)
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm.baseInfo
                  ? _c(
                      "div",
                      { staticClass: "progress-line" },
                      [
                        _c("van-progress", {
                          staticClass: "progress-bar",
                          attrs: {
                            "track-color": "#ebebeb",
                            "show-pivot": false,
                            percentage: _vm.baseInfo.currPercent,
                            "stroke-width": "4",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.baseInfo
                  ? _c("MyPLabel", {
                      staticClass: "progress-tip",
                      attrs: {
                        str: _vm.$t("lang.commonM.k464"),
                        numsOption: [{ value: _vm.baseInfo.needCoins || "" }],
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "level-body" }, [
          _c("div", { staticClass: "privileges-block" }, [
            _c("div", { staticClass: "block-title" }, [
              _vm._v(_vm._s(_vm.$t("lang.host.privileges"))),
            ]),
            _vm.baseInfo &&
            _vm.baseInfo.gradeRules &&
            _vm.baseInfo.gradeRules.length
              ? _c(
                  "div",
                  { ref: "levelNumberContainer", staticClass: "level-number" },
                  _vm._l(_vm.baseInfo.gradeRules, function (item, index) {
                    return _c(
                      "div",
                      {
                        ref: `levelItem${index}`,
                        refInFor: true,
                        class: { active: _vm.currentTab === index },
                        on: {
                          click: function ($event) {
                            return _vm.handleTabClick(index, item)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("lang.Lv")) +
                            "." +
                            _vm._s(item.grade) +
                            " "
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.currentCon && _vm.currentCon.length
              ? _c(
                  "div",
                  { staticClass: "level-pri-box" },
                  _vm._l(_vm.currentCon, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        class: [
                          "level-pri-item",
                          _vm.currentTab === 0 ? "item-off" : "item-on",
                        ],
                      },
                      [
                        _c("div", { staticClass: "level-pri-img" }, [
                          _c("img", {
                            attrs: {
                              src: _vm._f("imgPath")(item.icon),
                              alt: "",
                            },
                          }),
                        ]),
                        _c("div", { staticClass: "level-pri-text" }, [
                          _c("div", { staticClass: "tit" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                          _c("div", { staticClass: "con" }, [
                            _vm._v(_vm._s(item.content)),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "rule-block" }, [
            _c("div", { staticClass: "block-title" }, [
              _vm._v(_vm._s(_vm.$t("lang.host.levelRule"))),
            ]),
            _c("div", { staticClass: "block-tips" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k465"))),
            ]),
            _vm.baseInfo &&
            _vm.baseInfo.gradeRules &&
            _vm.baseInfo.gradeRules.length
              ? _c(
                  "table",
                  { staticClass: "table-box" },
                  [
                    _c("tr", { staticClass: "table-head" }, [
                      _c("th", [_vm._v(_vm._s(_vm.$t("lang.host.level")))]),
                      _c("th", [_vm._v(_vm._s(_vm.$t("lang.coupon.desc1")))]),
                    ]),
                    _vm._l(_vm.baseInfo.gradeRules, function (item, index) {
                      return _c(
                        "tr",
                        { key: index, staticClass: "table-item" },
                        [
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "level-item",
                                class: [!item.grade ? "level-off" : "level-on"],
                              },
                              [
                                _c("div", { staticClass: "level-icon" }),
                                _c("span", { staticClass: "level-txt" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("lang.Lv")) +
                                      "." +
                                      _vm._s(item.grade)
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _c("td", [_vm._v(_vm._s(item.coins))]),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }